var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6716 33.4521C23.3982 39.4677 18.4451 44.413 12.4294 44.6942C5.65599 44.9989 0.0544329 39.6005 0.0544329 32.8895C0.0544329 32.8895 -1.61744 12.0771 13.5701 2.92861C14.1716 2.56143 14.8826 3.2333 14.5388 3.85049C12.2107 8.07705 7.27318 17.6396 7.85912 21.7724C9.10912 21.3192 10.4763 21.0692 11.8826 21.0692C18.5857 21.0692 23.9841 26.6708 23.6716 33.4521ZM49.9841 35.9208C49.7107 41.9364 44.7576 46.8817 38.7419 47.163C31.9607 47.4755 26.3591 42.0771 26.3591 35.3661C26.3591 35.3661 24.6872 14.5536 39.8747 5.40518C40.4763 5.03799 41.1872 5.70986 40.8435 6.32705C38.5154 10.5536 33.5779 20.1161 34.1638 24.2489C35.4138 23.7958 36.781 23.5458 38.1872 23.5458C44.8982 23.538 50.2966 29.1395 49.9841 35.9208Z",
    fill: "#344157"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/Point.c895a2c4.svg";
export { ForwardRef as ReactComponent };